import { useEffect } from "react";
import SurveyCreatorWidget from "../components/SurveyCreatorWidget";
import SurveyComponent from "../components/SurveyComponent";

function App() {
  const params = new URLSearchParams(window.location.search);
  const mode = params.get("mode");

  useEffect(() => {
    const nextModeClass = mode === "creator" ? "creator-mode" : "embed-mode";
    const rootElement = document.documentElement;

    rootElement.classList.remove("creator-mode", "embed-mode");
    document.body.classList.remove("creator-mode", "embed-mode");

    rootElement.classList.add(nextModeClass);
    document.body.classList.add(nextModeClass);

    return () => {
      rootElement.classList.remove(nextModeClass);
      document.body.classList.remove(nextModeClass);
    };
  }, [mode]);

  if (mode === "creator") {
    return <SurveyCreatorWidget />;
  }

  return <SurveyComponent />;
}

export default App;
